var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mb-1"},[_c('b-badge',{attrs:{"variant":_vm.mapBadgeStyle(_vm.importAction)}},[_vm._v(_vm._s(_vm.$t(`content.bulk_upload.import_banner.${_vm.importAction}`)))]),_vm._v(" "),_c('span',{staticClass:"font-weight-bold"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }